import {Button, Card, Form, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import SubList from "../../components/SubList";
import {isReservedCondition} from "./reserved";
import ColorInput, {HEX_PATTERN} from "./ColorInput";

class Create extends React.Component {

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }


  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form} = this.props;
    const lockName = title === 'EDIT' && isReservedCondition(data);
    const formFilters = lockName && filters.name
      ? {...filters, name: {...filters.name, options: {...filters.name.options, disabledOnEdit: true}}}
      : filters;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(formFilters).map((item) => {
              if (item === 'color') {
                return <Form.Item key={item} label={sanitizeFieldName(formFilters[item].options.label || item)}>
                  {getFieldDecorator(item, {
                    rules: [{pattern: HEX_PATTERN, message: 'Enter a hex colour code like #52c41a'}],
                    initialValue: (data && data.color) || '',
                  })(<ColorInput/>)}
                </Form.Item>
              }
              if (formFilters[item].type === 'Array' && formFilters[item].schema) {
                return <SubList key={item} item={formFilters[item]} form={form} data={data[item]} title={title} resource={resource}/>
              } else {
                return getFormFieldByType(formFilters, item, getFieldDecorator, data, {title})
              }
            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
